import { IRework } from 'lib/types/clinic/projectTypes';
import { IProjectInfo, TScanmode } from 'lib/types/projectTypes';
import { createStoreWithSetters } from './utils';

interface IStoreProps {
  // project detail
  isProjectCreator: boolean;
  completeModal: boolean;
  isShowChat: boolean;
  chatOpen: boolean;
  currentTab: 0 | 1;
  tooth: any | null;
  teeth: any[];
  toothShade: any | null;
  scanMode: TScanmode | null;
  numbering: number;
  bridge: any | null;
  selectedTeethIsExpanded: any[] | null;
  reworkStatusModalOpen: boolean;
  reworkList: IRework[];
  projectCode: string;
  projectId: string;
  selectedSyncPartner: number | '';
  selectedSyncPartnerName: string | '';
  newSyncPartner: number | '';
  isOpenNewSyncModal: boolean;
  partnerRefresh: boolean;
  prevPartnerManager: number | null;
  historyOpen: boolean;
  queryPageTab: number;
  isPhotogrammetry: boolean;
}

export const useProjectDetailStore = createStoreWithSetters<IStoreProps>(
  {
    reworkStatusModalOpen: false,
    isProjectCreator: true,
    completeModal: false,
    isShowChat: false,
    chatOpen: false,
    currentTab: 0,
    tooth: null,
    teeth: [],
    toothShade: null,
    scanMode: null,
    numbering: 0,
    bridge: null,
    selectedTeethIsExpanded: null,
    reworkList: [],
    projectCode: '',
    projectId: '',
    selectedSyncPartner: '',
    selectedSyncPartnerName: '',
    newSyncPartner: '',
    isOpenNewSyncModal: false,
    partnerRefresh: false,
    prevPartnerManager: null,
    historyOpen: false,
    queryPageTab: 0,
    isPhotogrammetry: false,
  },
  'project_detail',
);
